"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var store_1 = require("../data/store/store");
var owa_options_core_1 = require("owa-options-core");
var legacy_1 = require("satcheljs/lib/legacy");
var owa_outlook_service_options_1 = require("owa-outlook-service-options");
exports.default = legacy_1.select({
    optionState: function () { return store_1.default(); },
    userOptions: function () {
        return owa_outlook_service_options_1.getOptionsForFeature(owa_outlook_service_options_1.OwsOptionsFeatureType.SkypeNotifications);
    },
})(function isSkypeOptionDirty(state) {
    var optionState = state.optionState, userOptions = state.userOptions;
    return (isOptionDirty(optionState.imNotification, userOptions.skypeMessageNotification) ||
        isOptionDirty(optionState.callNotification, userOptions.skypeCallingNotification));
});
function isOptionDirty(optionState, userOption) {
    return owa_options_core_1.getFallbackValueIfNull(optionState, userOption) !== userOption;
}
//# sourceMappingURL=isSkypeOptionDirty.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/general/owa-skype-option/lib/utils/isSkypeOptionDirty.js
// module id = 3375
// module chunks = 2 39